import PropTypes from 'prop-types'
import settings from '@nobia/zeus-components/lib/settings'
import styled, { rem, theme } from '@nobia/zeus-components/lib/styled'
import React, { useState } from 'react'
import { createCloudinaryUrl } from '../image/Image'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 3px;
`
const Image = styled.div`
  display: inline-block;
  background: ${p => `url(${p.src})`};
  background-position: center;
  background-color: ${p => p.name || 'black'};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border-radius: 50%;
  height: 23px;
  width: 23px;
  margin: 0 5px 3px 0;
`

const Circle = styled.div`
  display: inline-block;
  background-color: ${p => p.name || 'black'};
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  margin-right: 5px;
`
const Button = styled.span`
  background-color: ${theme('colors.toneA')};
  border-radius: 20px;
  font-weight: 100;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  display: flex;
  height: 23px;
  min-width: 23px;
  padding: 0 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`
const Close = styled.span`
  display: flex;
  font-size: ${rem(17)};
  line-height: ${rem(15)};
  ${() =>
    settings.brand === 'invita' &&
    `
    font-size: ${rem(17)};
    line-height: ${rem(17)};
    margin-top: -3px;
  `}
`

const Colors = ({ colors }) => {
  const [showMore, setShowMore] = useState(false)
  const remainder = colors.length - 3
  const showColors = showMore ? colors : colors.slice(0, 3)

  const handleClick = e => {
    e.stopPropagation()
    setShowMore(!showMore)
  }

  return (
    <Wrapper onClick={handleClick}>
      {showColors.map(({ name, src }) =>
        src ? (
          <Image
            key={name}
            src={createCloudinaryUrl(src, {
              width: 40,
              height: 40,
              crop: 'fill',
            })}
            name={name}
            alt={name}
          />
        ) : (
          <Circle key={name} src={src} name={name} alt={name} />
        )
      )}
      {remainder > 0 && (
        <Button>{showMore ? <Close>&times;</Close> : `+${remainder}`}</Button>
      )}
    </Wrapper>
  )
}

Colors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default Colors
